import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "result-panel"
};
var _hoisted_2 = {
  class: "main"
};
var _hoisted_3 = {
  key: 0,
  class: "result-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "cover"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "info"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "preview-header"
};
var _hoisted_10 = {
  class: "header-right"
};
var _hoisted_11 = {
  key: 0,
  class: "preview-content"
};
var _hoisted_12 = ["src"];
import SideBar from './common/SideBar';
import Empty from './common/Empty';
import UploadFile from './common/UploadFile';
import ChoiseCourse from './common/ChoiseCourse';

/* 工具 */
import { ref, reactive, inject, onMounted } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { LEFT_BAR_MAP } from '../const';
import { getStore } from '@/util/store';
import { debounce } from '@/util/index';
import { getEnvName, getHostName } from '@/util/env';
import { fileClass, imgCoverMap } from '@/utils/index';

/* api */
import { addResult, delResult, getResultList, courseCopy } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'Result',
  setup: function setup(__props) {
    /* 组件 */
    var userInfo = getStore({
      name: 'userInfo'
    });
    var discussId = inject('discussId');
    var discussInfo = inject('discussInfo');
    var form = ref();
    var state = reactive({
      resultList: [],
      addFileShow: false,
      rules: {
        type: [{
          required: true
        }],
        file: [{
          required: true
        }]
      },
      formData: {
        type: 0,
        file: [],
        course: []
      },
      previewShow: false,
      // 预览弹窗
      previewInfo: {} // 预览信息
    });

    /* 事件 */
    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'fileAdd') {
        state.addFileShow = true;
      }
    };

    // 跳转详情
    var toDetail = function toDetail(item) {
      var type = item.fileSuffix === 'C' ? 1 : 0;
      state.previewInfo = {
        type: type,
        title: item.title
      };
      if (type === 0) {
        // 资源预览
        state.previewInfo.url = item.courseIdOrUrl;
      } else if (type === 1) {
        // 学程预览
        var url = '';
        var env_name = getEnvName();
        var hostName = getHostName();
        var token = getStore({
          name: 'access_token'
        });
        if (Number(item.version) === 2) {
          // 新
          url = "//".concat(env_name || 'edu-', "course.").concat(hostName, "/preview?courseId=").concat(item.courseIdOrUrl, "&token=").concat(token);
        } else {
          // 旧
          url = env_name ? "//".concat(env_name, "web.").concat(hostName, "/courseDetail?id=").concat(item.courseIdOrUrl, "&token=").concat(token) : "//web.zhixuehuijiao.cn/courseDetail?id=".concat(item.courseIdOrUrl, "&token=").concat(token);
        }
        state.previewInfo.url = url;
        state.previewInfo.courseId = item.courseIdOrUrl;
      }
      state.previewShow = true;
    };

    // 文件封面图
    var fileCover = function fileCover(item) {
      var res = null;
      if (item.fileSuffix === 'C') {
        res = require('@/assets/icon/course.png');
      } else {
        var fileType = fileClass(item.fileSuffix);
        res = imgCoverMap[fileType];
      }
      return res;
    };

    // 关闭弹窗
    var onClose = function onClose() {
      form.value.reset();
      state.formData.file = [];
      state.formData.course = [];
    };

    // 弹窗确认
    var onConfirm = debounce(function () {
      form.value.submit();
    });

    // 提交
    var onSubmit = function onSubmit() {
      form.value.validate().then(function (result) {
        if (result && Object.keys(result).length) {
          var _Object$values$;
          var firstError = (_Object$values$ = Object.values(result)[0]) === null || _Object$values$ === void 0 || (_Object$values$ = _Object$values$[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.message;
          MessagePlugin.warning(firstError);
        }
        if (result === true) {
          var data = {
            discussId: discussId.value,
            loaderId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
            loaderName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
            achievements: []
          };
          if (state.formData.type === 0) {
            var _state$formData$file;
            data.achievements = (_state$formData$file = state.formData.file) === null || _state$formData$file === void 0 ? void 0 : _state$formData$file.map(function (e) {
              return {
                courseIdOrUrl: e.url,
                title: e.name,
                fileSuffix: e.suffix,
                version: 2,
                source: 2
              };
            });
          } else {
            var _state$formData$cours;
            data.achievements = (_state$formData$cours = state.formData.course) === null || _state$formData$cours === void 0 ? void 0 : _state$formData$cours.map(function (e) {
              return {
                courseIdOrUrl: e.id,
                title: e.title,
                fileSuffix: 'C',
                version: e.version,
                source: e.source
              };
            });
          }
          addResult(data).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('添加成功！');
              getList();
              state.addFileShow = false;
              state.formData.file = [];
              state.formData.course = [];
            }
          });
        }
      });
    };

    // 切换类型
    var typeChange = function typeChange(type) {
      if (type === 0) {
        delete state.rules.course;
        state.rules.file = [{
          required: true
        }];
        state.formData.file = [];
      } else {
        delete state.rules.file;
        state.rules.course = [{
          required: true
        }];
        state.formData.course = [];
      }
    };

    // 删除文件
    var delFile = function delFile(id) {
      var dialog = DialogPlugin({
        header: '删除文件',
        body: '是否删除该文件',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          delResult(discussId.value, id).then(function (res) {
            if (res.data.code === 0) {
              MessagePlugin.success('删除成功！');
              dialog.destroy();
              getList();
            }
          });
        }
      });
    };

    // 保存学程
    var courseSave = function courseSave() {
      courseCopy(discussId.value, state.previewInfo.courseId).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('已保存至“创作中心”的“创作”中！');
        }
      });
    };

    // 下载文件
    var downloadFile = function downloadFile() {
      var url = state.previewInfo.url;
      var name = state.previewInfo.title;
      return new Promise(function (resolve) {
        fetch(url).then(function (response) {
          return response.blob();
        }).then(function (blob) {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          MessagePlugin.success('下载成功！');
          resolve(true);
        }).catch(function (error) {
          resolve(false);
        });
      });
    };

    // 关闭预览
    var previewClose = function previewClose() {
      state.previewInfo = {};
      state.previewShow = false;
    };

    // 获取列表
    var getList = function getList() {
      getResultList(discussId.value).then(function (res) {
        if (res.data.code === 0) {
          state.resultList = res.data.data || [];
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getList();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_radio = _resolveComponent("t-radio");
      var _component_t_radio_group = _resolveComponent("t-radio-group");
      var _component_t_form_item = _resolveComponent("t-form-item");
      var _component_t_form = _resolveComponent("t-form");
      var _component_t_dialog = _resolveComponent("t-dialog");
      var _component_preview = _resolveComponent("preview");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['result'],
        onTabChange: sideBarChange
      }, null, 8, ["barList"]), _createElementVNode("div", _hoisted_2, [state.resultList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.resultList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "result-item",
          onClick: function onClick($event) {
            return toDetail(item);
          }
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: fileCover(item),
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("span", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.uname), 1), _createElementVNode("span", null, _toDisplayString(item.loadDate), 1)]), _unref(userInfo).id === _unref(discussInfo).creatorId || _unref(userInfo).id === item.userId ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "delete",
          onClick: _withModifiers(function ($event) {
            return delFile(item.id);
          }, ["stop"])
        }, [_createVNode(_component_svg_icon, {
          name: "dialog-close-white",
          size: "10"
        })], 8, _hoisted_8)) : _createCommentVNode("", true)], 8, _hoisted_4);
      }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "result"
      })), _createVNode(_component_t_dialog, {
        visible: state.addFileShow,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return state.addFileShow = $event;
        }),
        header: "添加资料",
        width: "480px",
        placement: "center",
        onClose: onClose,
        onConfirm: _unref(onConfirm)
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_form, {
            ref_key: "form",
            ref: form,
            data: state.formData,
            rules: state.rules,
            showErrorMessage: false,
            "label-align": "top",
            resetType: "initial",
            onSubmit: onSubmit
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_form_item, {
                label: "资料类型",
                name: "type"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_t_radio_group, {
                    modelValue: state.formData.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return state.formData.type = $event;
                    }),
                    "default-value": 0,
                    onChange: typeChange
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_t_radio, {
                        value: 0
                      }, {
                        default: _withCtx(function () {
                          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("文件", -1)]));
                        }),
                        _: 1
                      }), _createVNode(_component_t_radio, {
                        value: 1
                      }, {
                        default: _withCtx(function () {
                          return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode("学程", -1)]));
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), state.formData.type === 0 ? (_openBlock(), _createBlock(_component_t_form_item, {
                key: 0,
                label: "上传文件",
                name: "file"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(UploadFile), {
                    list: state.formData.file,
                    "onUpdate:list": _cache[1] || (_cache[1] = function ($event) {
                      return state.formData.file = $event;
                    }),
                    multiple: ""
                  }, null, 8, ["list"])];
                }),
                _: 1
              })) : _createCommentVNode("", true), state.formData.type === 1 ? (_openBlock(), _createBlock(_component_t_form_item, {
                key: 1,
                label: "关联学程",
                name: "course"
              }, {
                default: _withCtx(function () {
                  return [state.addFileShow ? (_openBlock(), _createBlock(_unref(ChoiseCourse), {
                    key: 0,
                    checked: state.formData.course,
                    "onUpdate:checked": _cache[2] || (_cache[2] = function ($event) {
                      return state.formData.course = $event;
                    }),
                    disableId: _ctx.checkCourseId
                  }, null, 8, ["checked", "disableId"])) : _createCommentVNode("", true)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["data", "rules"])];
        }),
        _: 1
      }, 8, ["visible", "onConfirm"]), _createVNode(_component_t_dialog, {
        visible: state.previewShow,
        "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
          return state.previewShow = $event;
        }),
        class: "preview-dialog",
        width: "85vw",
        placement: "center",
        closeBtn: false,
        footer: false
      }, {
        header: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(state.previewInfo.title), 1), _createElementVNode("div", _hoisted_10, [state.previewInfo.type === 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn",
            onClick: courseSave
          }, [_createVNode(_component_svg_icon, {
            name: "resource-save"
          }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "保存", -1))])) : _createCommentVNode("", true), state.previewInfo.type === 0 ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn",
            onClick: downloadFile
          }, [_createVNode(_component_svg_icon, {
            name: "resource-download"
          }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "下载", -1))])) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
            class: "close",
            name: "dialog-close-white",
            onClick: previewClose
          })])])];
        }),
        default: _withCtx(function () {
          return [state.previewShow ? (_openBlock(), _createElementBlock("div", _hoisted_11, [state.previewInfo.type === 0 ? (_openBlock(), _createBlock(_component_preview, {
            key: 0,
            path: state.previewInfo.url
          }, null, 8, ["path"])) : _createCommentVNode("", true), state.previewInfo.type === 1 ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            src: state.previewInfo.url,
            frameborder: "0"
          }, null, 8, _hoisted_12)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"])])]);
    };
  }
};